module.exports = __webpack_public_path__ + "static/media/logo.0519c615.png";